import React, { forwardRef, useState } from 'react'
import { TextField, InputAdornment, IconButton, TextFieldProps } from '@mui/material'
import { VisibilityRoundedIcon } from '../../../icons/VisibilityRoundedIcon'
import { VisibilityOffRoundedIcon } from '../../../icons/VisibilityOffRoundedIcon'

export const PasswordInput = forwardRef<HTMLInputElement, TextFieldProps>(
  function PasswordInput(props, ref) {
    const [showPassword, setShowPassword] = useState(false)

    const handleClickShowPassword = () => setShowPassword((show) => !show)

    return (
      <TextField
        {...props}
        inputRef={ref}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          ...props.InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
              >
                {showPassword ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    )
  }
)

PasswordInput.displayName = 'PasswordInput'
